import { type FigmaTextColor, textColors } from '../tokens/text-colors'

export type TypographyTone = keyof typeof textColors

export const toneClasses = Object.fromEntries(
    Object.entries(textColors as Record<string, FigmaTextColor>).map(([tone, color]) => [
        tone,
        color.className,
    ]),
) as Record<TypographyTone, string>

export const toneNames = Object.keys(textColors) as TypographyTone[]

export const figmaColorFor = (tone: TypographyTone): FigmaTextColor =>
    textColors[tone] as FigmaTextColor
